<template>
  <list-row
    class="ics-list-row-component row"
    @row-clicked="$emit('row-clicked')"
  >
    <template v-if="showThumbnail && thumbnail">
      <!--
        Using a div here to take advantage of background position/size.
        We could/should use an img and the object-fit and object-position properties to do the same but it is not supported in IE11.
      -->
      <div
        v-if="thumbnail"
        class="thumbnail thumbnail-img"
        role="img"
        :aria-label="`Media for ${name}`"
        :style="{ backgroundImage: thumbnail }"
      />
      <div
        v-else
        class="thumbnail"
      />
    </template>
    <div class="name">
      {{ name }}
    </div>
    <div class="action-container">
      <span
        v-if="states.length > 1"
        class="state-text"
      >
        <icon
          v-if="completed"
          name="check"
          variant="white"
          class="completed-icon"
        />
        {{ stateText }}
      </span>
      <icon
        name="arrow"
        class="arrow"
        :variant="iconVariant"
      />
    </div>
  </list-row>
</template>

<script>
import Icon from '@components/singletons/icon';
import ListRow from '@components/ui/listRow';

import GlobalMixin from '@/mixins/global';

export default {
  name: 'ICSListRow',
  components: { ListRow, Icon },
  mixins: [GlobalMixin],
  props: {
    grouping: {
      type: Object,
    },
    name: {
      type: String,
    },
    showThumbnail: {
      type: Boolean,
    },
    thumbnailUrl: {
      type: String,
    },
  },
  emits: ['row-clicked'],
  computed: {
    completed() {
      return this.states && this.states.length === 3;
    },
    iconVariant() {
      const masteryApp = this.$store.getters['app/isMasteryApp'];
      if (masteryApp) {
        return 'mastery';
      } else {
        return '4fb9de';
      }
    },
    states() {
      const topicIds = this.grouping.assetAssociations.map(aa => aa.assetBId);
      return topicIds.map(tid => this.$store.getters['topicStates/topicStates'][tid]).filter(s => s);
    },
    stateText() {
      // This will only be access if state exists so we can make an assumption that we will always be either started or completed
      return this.completed ? 'Complete' : 'Continue';
    },
    thumbnail() {
      if (this.thumbnailUrl) {
        return `url("${this.thumbnailUrl}")`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ics-list-row-component {
  font-size: rem-calc(14);
  color: #000000;

  .thumbnail {
    align-items: center;
    background-color: #ebedef;
    display: flex;
    flex-shrink: 0;
    height: 39px;
    justify-content: center;
    width: 70px;

    &.thumbnail-img {
      background-position: center;
      background-size: cover;
    }
  }

  .name {
    align-items: center;
    color: #000000;
    display: flex;
    flex: 1;
    font-size: rem-calc(14);
    margin-left: rem-calc(24);
  }

  .action-container {
    display: flex;
    align-items: center;
    flex-direction: row;
    min-width: rem-calc(60);

    @include breakpoint(small) {
      flex-direction: column-reverse;
      min-width: rem-calc(40);
    }

    .state-text {
      margin-right: rem-calc(20);

      .completed-icon {
        width: rem-calc(10);
        height: rem-calc(10);
        padding: 2px;
        border-radius: 100%;
        background-color: #00b46d;
        vertical-align: -2px;
        margin-right: rem-calc(4);
      }
    }

    .arrow {
      margin-left: auto;

      @include breakpoint(small) {
        margin-left: 0;
      }
    }
  }
}
</style>
